import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import ApplicationTitle from "@quest_editor/components/ApplicationTitle";

const WithApplicationTitle = () => {
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
        <ApplicationTitle />
      </Box>
      <Outlet />
    </>
  );
};

export default WithApplicationTitle;
